import type { JSX } from "react";

export type Notification = {
  id: string;
  type: string;
  title: string;
  description: string;
  time: string;
  icon: JSX.Element;
  read: boolean;
  link: string;
};

/** Trống cho đến khi có API thông báo */
export const notifications: Notification[] = [];
